import PropTypes from 'prop-types';
import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';

import { VerticalTableMarquee } from '@powdr/components';
import { LeaderboardDisplayMap, LeaderboardStatTypes } from '@powdr/constants';
import { useLeaderboard } from '@powdr/hooks';
import {
  getNumberWithCommas,
  toProperCase,
} from '@powdr/utils';

export const WearlynxLeaderboard = ({
  className = '',
  tableTitle,
  timeframe,
  stat,
  isWrapperless = false,
  enableUserScrolling = false,
  parentColorProfile,
}) => {
  const [data, setData] = useState(null);
  const leaderboardData = useLeaderboard(
    timeframe,
    stat,
  );

  const getFormattedStat = useCallback(
    (s) => (
      (stat === LeaderboardStatTypes.VERTICAL_FEET || stat === LeaderboardStatTypes.LINEAR_FEET)
        ? `${getNumberWithCommas(s)}'`
        : s),
    [stat],
  );

  useEffect(() => {
    if (leaderboardData && leaderboardData?.length > 0) {
      setData(
        leaderboardData.map((i) => ({
          name: `${toProperCase(i?.display)} ${i?.last_initial}.`,
          guid: i?.guid,
          photoSrcUrl: (i?.guid && !!i?.profile_photo) && `https://cdn.skilynx.com/user_profile_photos/${i?.guid}.jpg`,
          placeholderText: `${i?.display.charAt(0)}${i?.last_initial}`,
          stat: getFormattedStat(i?.[stat]),
        })),
      );
    }
  }, [leaderboardData, stat, getFormattedStat]);

  if (!data) return null;

  return (
    <VerticalTableMarquee
      className={className}
      isWrapperless={isWrapperless}
      is5050={false}
      showItemIndex
      showPhotos
      marqueeTitle={tableTitle}
      enableUserScrolling={enableUserScrolling}
      parentColorProfile={parentColorProfile}
      emptyMessage="Track your laps in the Snowbird App and climb the leaderboard."
      leftColumnTitle="Rider"
      rightColumnTitle={LeaderboardDisplayMap?.[stat]?.displayName}
      data={data}
    />
  );
};

WearlynxLeaderboard.propTypes = {
  className: PropTypes.string,
  tableTitle: PropTypes.string,
  timeframe: PropTypes.string.isRequired,
  stat: PropTypes.string.isRequired,
  parentColorProfile: PropTypes.string,
  isWrapperless: PropTypes.bool,
  enableUserScrolling: PropTypes.bool,
};
